import { render, staticRenderFns } from "./RegistrationStatus.vue?vue&type=template&id=4ea0581b&scoped=true&"
import script from "@/views/RegistrationStatus/RegistrationStatus.ts?vue&type=script&lang=ts&"
export * from "@/views/RegistrationStatus/RegistrationStatus.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RegistrationStatus/RegistrationStatus.scss?vue&type=style&index=0&id=4ea0581b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea0581b",
  null
  
)

export default component.exports